import { render } from "./Filter-Menu.vue?vue&type=template&id=11b51850&scoped=true"
import script from "./Filter-Menu.vue?vue&type=script&lang=js"
export * from "./Filter-Menu.vue?vue&type=script&lang=js"

import "./Filter-Menu.vue?vue&type=style&index=0&id=11b51850&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-11b51850"

export default script